// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2CN3n","paramInput":"JobSimulator_paramInput__13rid","input":"JobSimulator_input__2scS1"};